module.exports = __webpack_public_path__ + "img/schedule.eb36e0d1.svg";